/** European Portuguese. English source strings are the fallback catalogue. */
export const portuguese: Record<string, string> = {
  "Flight and stay searches are off for your current choices.":
    "As pesquisas de voos e alojamento estão desativadas de acordo com as tuas escolhas.",
  "Change search choices": "Alterar opções de pesquisa",
  "This message ID was already used for different text.":
    "Esta mensagem já foi usada com outro texto. Atualiza a página e tenta novamente.",
  "The conversation has moved on. Reload before retrying.":
    "A conversa já avançou. Atualiza a página antes de tentar novamente.",
  "Remembered for this plan": "Guardado para este plano",
  "Flights not needed": "Sem necessidade de voos",
  "Flights already arranged": "Voos já tratados",
  "Flight planning requested": "Planear voos",
  "Accommodation not needed": "Sem necessidade de alojamento",
  "Accommodation already arranged": "Alojamento já tratado",
  "Accommodation planning requested": "Planear alojamento",
  "No work planning": "Sem planeamento de trabalho",
  "Work schedule already set": "Horário de trabalho já definido",
  "Work planning requested": "Planear o trabalho",
  "Tell me if your choices change.": "Diz-me se mudares de ideias.",
  "Your answers are remembered, but the planning service is unavailable. Please try again later.":
    "As tuas respostas estão guardadas, mas o serviço de planeamento está indisponível. Tenta novamente mais tarde.",
  "The planner took too long. Your answers are remembered and your saved plan is unchanged. Please retry.":
    "O planeador demorou demasiado. As tuas respostas estão guardadas e o plano não foi alterado. Tenta novamente.",
  "Your answers are remembered. I couldn’t produce a consistent reply this time. Please retry.":
    "As tuas respostas estão guardadas. Desta vez não foi possível dar uma resposta coerente. Tenta novamente.",
  "Your conversation changed in another window. Reload before continuing.":
    "A conversa foi alterada noutra janela. Atualiza a página antes de continuar.",
  "This message was already processed. Reload the latest conversation.":
    "Esta mensagem já foi processada. Atualiza a página para ver a conversa mais recente.",
  "Check dates": "Rever datas",
  "SAMPLE GUIDE · ILLUSTRATIVE PRICES": "GUIA DE EXEMPLO · PREÇOS ILUSTRATIVOS",
  "Explore the guide your own plan can become. These are examples, not live quotes or confirmed bookings.":
    "Descobre o guia em que o teu plano se pode transformar. São exemplos, sem preços em tempo real nem reservas confirmadas.",
  "Planned route. Confirm times, baggage and fares before booking.":
    "Percurso planeado. Confirma horários, bagagem e tarifas antes de reservar.",
  "Lisbon, at your own pace.": "Lisboa, ao teu ritmo.",
  "An example plan with illustrative prices. Four nights in the city, focused mornings, evenings by the river, and a Saturday escape to Sintra.":
    "Um plano de exemplo com preços ilustrativos. Quatro noites na cidade, manhãs de concentração, fins de tarde junto ao rio e uma escapadinha a Sintra no sábado.",
  London: "Londres",
  "Quiet work calls": "Chamadas de trabalho tranquilas",
  "No car": "Sem carro",
  "Room for spontaneous plans": "Espaço para planos espontâneos",
  "London to Lisbon": "Londres a Lisboa",
  "An illustrative return-flight allowance for each traveller. Choose an actual flight and confirm baggage before booking.":
    "Uma estimativa de ida e volta por viajante. Escolhe um voo real e confirma a bagagem antes de reservar.",
  "An apartment in Príncipe Real": "Um apartamento no Príncipe Real",
  "Príncipe Real, Lisbon": "Príncipe Real, Lisboa",
  "Look for a quiet bedroom, a proper desk and a recent internet speed test. Keep your daily essentials within walking distance.":
    "Procura um quarto tranquilo, uma secretária adequada e um teste recente à velocidade da internet. Escolhe um lugar com o essencial do dia a dia a uma distância que se faça a pé.",
  "A desk when you need one": "Uma secretária quando precisas",
  "An example allowance for two day passes on each working day. Confirm call privacy, opening hours and whether advance booking is needed.":
    "Uma estimativa para dois passes por dia de trabalho. Confirma a privacidade para chamadas, os horários e se é preciso reservar.",
  "An early riverside walk": "Um passeio matinal junto ao rio",
  "Ribeira das Naus, Lisbon": "Ribeira das Naus, Lisboa",
  "A slow start by the water before the working day. Leave room for coffee on the way back.":
    "Começa o dia devagar, junto à água, antes de trabalhar. Deixa tempo para um café no regresso.",
  "A Saturday in Sintra": "Um sábado em Sintra",
  "Choose one palace or a walking route instead of trying to see everything. Confirm timed entry, train times and the return journey before setting out.":
    "Escolhe um palácio ou um percurso a pé, sem tentar ver tudo. Confirma a hora de entrada, os comboios e o regresso antes de sair.",
  "Airport and local transport": "Aeroporto e transportes locais",
  "Lisbon Airport": "Aeroporto de Lisboa",
  "A planning allowance, not a fare quote. Check current transport fares and the connection to your accommodation.":
    "Uma estimativa para o plano, não uma tarifa obtida em tempo real. Confirma os preços dos transportes e a ligação ao alojamento.",
  "Meals and groceries": "Refeições e compras",
  "A daily allowance per traveller for five days. Adjust it to your own routine.":
    "Uma estimativa diária por viajante durante cinco dias. Ajusta-a à tua rotina.",
  "Mobile data": "Dados móveis",
  "Travel insurance": "Seguro de viagem",
  "Baggage and airline extras": "Bagagem e extras da companhia",
  "Confirm your workspace": "Confirmar o espaço de trabalho",
  "Ask for a photo of the desk, a recent speed test and information about daytime noise.":
    "Pede uma fotografia da secretária, um teste recente de velocidade e informações sobre o ruído durante o dia.",
  "Keep the essentials together": "Guardar o essencial num só lugar",
  "Save your tickets, check-in instructions, insurance details and important contact numbers before departure.":
    "Guarda bilhetes, instruções de entrada, dados do seguro e contactos importantes antes da partida.",
  "Illustrative example only. Confirm details and prices before booking.":
    "Apenas um exemplo ilustrativo. Confirma detalhes e preços antes de reservar.",
  "An expense": "Uma despesa",
  Accommodation: "Alojamento",
  Transport: "Transportes",
  "Food & groceries": "Refeições e compras",
  Activities: "Atividades",
  Workspace: "Espaço de trabalho",
  "Other costs": "Outros custos",
  Quantity: "Quantidade",
  "Budget category": "Categoria do orçamento",
  Automatic: "Automática",
  "Per person": "Por pessoa",
  " / person": " / pessoa",
  "Enter a unit price and quantity. A provider total covering the whole party or stay should use Once / total and quantity 1.":
    "Indica o preço unitário e a quantidade. Um total do fornecedor para todo o grupo ou estadia deve usar Uma vez / total e quantidade 1.",
  "Compare this route": "Comparar este percurso",
  "Opens a search for the route and dates, not this exact fare. Confirm the flight and price there.":
    "Abre uma pesquisa para o percurso e as datas, sem garantir esta tarifa específica. Confirma aí o voo e o preço.",
  "Map search": "Pesquisar no mapa",
  "YOUR PERSONAL TRAVEL GUIDE": "O TEU GUIA DE VIAGEM",
  "The places you choose. The details that matter. All in one place.":
    "Os lugares que escolhes. Os detalhes que importam. Tudo num só lugar.",
  "{count} traveller": "{count} viajante",
  "{count} travellers": "{count} viajantes",
  "{count} day": "{count} dia",
  "{count} days": "{count} dias",
  "{count} person": "{count} pessoa",
  "{count} people": "{count} pessoas",
  "{count} adult": "{count} adulto",
  "{count} adults": "{count} adultos",
  "{count} stops": "{count} escalas",
  Nonstop: "Direto",
  Return: "Regresso",
  "Time open": "Hora em aberto",
  "Times to confirm": "Horários por confirmar",
  "Quoted itinerary. Reconfirm times, baggage and fare conditions with the provider.":
    "Itinerário do orçamento. Confirma horários, bagagem e condições da tarifa junto do fornecedor.",
  "Source & checks": "Fonte e verificações",
  "Keep important details under review before booking.":
    "Confirma os detalhes importantes antes de reservar.",
  "THE BIG PICTURE": "A VIAGEM NUM RELANCE",
  "Your starting point": "O teu ponto de partida",
  Days: "Dias",
  "Plan items": "Elementos",
  Booked: "Reservados",
  "A guide for the trip you want to take.":
    "Um guia para a viagem que queres fazer.",
  "Your days": "Os teus dias",
  "Stay & work": "Ficar e trabalhar",
  "Flexible ideas": "Ideias em aberto",
  "Itemised budget": "Orçamento detalhado",
  "Before you go": "Antes de partir",
  "Trip at a glance": "Viagem num relance",
  "Known plan cost": "Custo conhecido do plano",
  "Not priced yet": "Ainda sem preços",
  "Estimate, not a final bill": "Estimativa, sem valor de fatura",
  "Multiple currencies": "Várias moedas",
  "Budget coverage": "Preços definidos",
  "Cost-bearing items priced": "Elementos com custos definidos",
  "Still to price": "Por orçamentar",
  "Unknown costs are not zero": "Custos desconhecidos não são zero",
  "Listed cost items are accounted for":
    "Custos dos elementos listados incluídos",
  "Practical checklist": "Lista de tarefas",
  "Marked complete by you": "Marcadas como concluídas por ti",
  "Make the days your own.": "Vive os dias ao teu ritmo.",
  "Your dated plans, in order. Leave room for the unexpected.":
    "Os teus planos com data, por ordem. Deixa espaço para o inesperado.",
  "A good place to land.": "Um bom lugar para ficar.",
  "Your accommodation and workspaces, with the details worth checking.":
    "Os teus alojamentos e espaços de trabalho, com os detalhes a confirmar.",
  "Good things without a fixed time.": "Boas ideias, sem hora marcada.",
  "These ideas have no date yet. Add them to a day when the rhythm feels right.":
    "Estas ideias ainda não têm data. Encaixa-as num dia quando fizer sentido.",
  "Every item. A clearer picture.": "Cada detalhe. Contas mais claras.",
  "Unit rates, quantities and totals for everything in your plan. Missing prices remain visible.":
    "Preços unitários, quantidades e totais de tudo o que está no plano. Os preços em falta ficam à vista.",
  "Partial estimate": "Estimativa parcial",
  "Known estimates": "Estimativas conhecidas",
  "Booked / completed": "Reservado / concluído",
  "Still estimated": "Ainda estimado",
  "{amount} above budget": "{amount} acima do orçamento",
  "{amount} remaining": "{amount} de margem",
  "Booked does not mean paid. Different currencies are kept separate, and unknown costs are not included in the totals.":
    "Reservado não significa pago. As moedas são apresentadas em separado e os custos desconhecidos não entram nos totais.",
  "Every item in this plan": "Todos os elementos deste plano",
  "Item / category": "Elemento / categoria",
  "Unit rate": "Preço unitário",
  "Basis × quantity": "Base × quantidade",
  "Item total": "Total do elemento",
  "Dates needed": "Faltam datas",
  "No cost assigned": "Sem custo atribuído",
  "Not priced": "Preço por definir",
  "Keep these in the picture.": "Não percas estes de vista.",
  "Add the missing prices or dates in the planner to complete your estimate.":
    "Adiciona os preços ou as datas em falta no planeador para completar a estimativa.",
  "Less to hold in your head.": "Menos detalhes para decorar.",
  "Your reminders and the checks that help the plan fit together.":
    "Os teus lembretes e as verificações que ajudam a juntar o plano.",
  "Your working rhythm": "O teu ritmo de trabalho",
  "Preferred local finish": "Hora limite local desejada",
  "No reminders added yet. Keep tickets, transfers and practical details in your plan as they become relevant.":
    "Ainda não há lembretes. Guarda bilhetes, transfers e detalhes práticos no plano à medida que forem precisos.",
  "Suggested details are unverified. Booking status is recorded by you; this guide does not make or cancel reservations.":
    "As sugestões não estão verificadas. O estado das reservas é registado por ti; este guia não faz nem cancela reservas.",
  "Snapshot created": "Versão criada em",
  "The travel provider could not authorise this search. Please contact support.":
    "O fornecedor de viagens não autorizou esta pesquisa. Contacta o suporte.",
  "The travel provider's request limit has been reached. Please try again later.":
    "Foi atingido o limite de pedidos do fornecedor de viagens. Tenta novamente mais tarde.",
  "The travel provider took too long to respond. Please try again.":
    "O fornecedor de viagens demorou demasiado a responder. Tenta novamente.",
  "The travel provider is temporarily unavailable. Please try again.":
    "O fornecedor de viagens está temporariamente indisponível. Tenta novamente.",
  "The travel provider returned an unsupported response. Please try again later.":
    "Não foi possível interpretar a resposta do fornecedor de viagens. Tenta novamente mais tarde.",
  "The provider could not find that location. Try a city name or airport code.":
    "O fornecedor não encontrou esse local. Experimenta o nome de uma cidade ou o código de um aeroporto.",
  "The provider could not complete this search. Check the route and dates.":
    "O fornecedor não conseguiu concluir a pesquisa. Confirma o percurso e as datas.",
  "The provider could not complete the search. Your saved plan is unchanged.":
    "O fornecedor não conseguiu concluir a pesquisa. O plano guardado não foi alterado.",
  "The flight provider returned a quote but no direct booking link.":
    "O fornecedor devolveu um preço para o voo, mas não uma ligação direta para reservar.",
  "The hotel provider returned a quote but no direct property link.":
    "O fornecedor devolveu um preço para o alojamento, mas não uma ligação direta para a propriedade.",
  "{count} night": "{count} noite",
  "{count} nights": "{count} noites",
  "{count} planned item": "{count} elemento planeado",
  "{count} planned items": "{count} elementos planeados",
  "Research / reference link": "Ligação de pesquisa / referência",
  "The planner took too long. Your saved plan is unchanged. Please try a smaller request.":
    "O assistente demorou demasiado. O plano guardado não foi alterado. Tenta um pedido mais pequeno.",
  "Create HTML website": "Criar site HTML",
  "Creating HTML…": "A criar o HTML…",
  "Couldn’t create the HTML file. Please try again.":
    "Não foi possível criar o ficheiro HTML. Tenta novamente.",
  "Website preview": "Pré-visualizar site",
  "Edit plan": "Editar plano",
  "Plan views": "Vistas do plano",
  "Open full website": "Abrir site completo",
  "Open plan website": "Abrir site do plano",
  "Your website updates when the plan is saved. Create HTML downloads a standalone snapshot; it does not publish your details online.":
    "O site é atualizado quando guardas o plano. Criar HTML descarrega uma versão autónoma; não publica os teus dados online.",
  "A PLAN OF YOUR OWN": "UM PLANO À TUA MEDIDA",
  "The plan": "O plano",
  "Your plan": "O teu plano",
  "Your travel plan": "O teu plano de viagem",
  "YOUR PLAN, TAKING SHAPE": "O TEU PLANO A GANHAR FORMA",
  "BUILD YOUR PLAN": "CONSTRÓI O TEU PLANO",
  "The shape of your trip": "A tua viagem, ao detalhe",
  "Set dates & preferences": "Definir datas e preferências",
  "Your ideas. Your plans. A little room for possibility.":
    "As tuas ideias. Os teus planos. Espaço para novas possibilidades.",
  "The idea behind this trip": "A ideia para esta viagem",
  "A day exploring somewhere new, a road trip, or a longer stay…":
    "Um dia a descobrir um lugar novo, uma viagem de carro ou uma estadia mais longa…",
  "Plan overnight accommodation": "Planear alojamento para pernoitar",
  "{count} ideas, places, and practical details":
    "{count} ideias, lugares e detalhes práticos",
  "Practical details": "Detalhes práticos",
  "The places. The moments. Your pace.":
    "Os lugares. Os momentos. O teu ritmo.",
  "A plan you can make your own. Each option keeps its source and booking status.":
    "Um plano à tua medida. Cada opção mantém a sua fonte e o estado da reserva.",
  "A starting point for something good.": "Um ponto de partida para algo bom.",
  "Add places, activities, or practical details to bring this page to life.":
    "Adiciona lugares, atividades ou detalhes práticos para dar vida a esta página.",
  "Known estimates for the items in this plan":
    "Estimativas conhecidas para os elementos deste plano",
  "Booked by you": "Reservado por ti",
  Done: "Concluído",
  "Open provider": "Abrir fornecedor",
  "Check price / book with provider": "Ver preço / reservar no fornecedor",
  "Provider booking link (optional)":
    "Ligação de reserva no fornecedor (opcional)",
  "This link becomes a booking button on your plan website. Payment and reservations happen with the provider.":
    "Esta ligação aparece como botão de reserva no site do plano. O pagamento e a reserva são feitos junto do fornecedor.",
  "Bookings are made directly with providers. Check availability, final prices, and cancellation terms on their websites.":
    "As reservas são feitas diretamente junto dos fornecedores. Confirma a disponibilidade, os preços finais e as condições de cancelamento nos respetivos sites.",
  "Plan version {revision}": "Versão {revision} do plano",
  "Explore somewhere nearby": "Descobrir um lugar por perto",
  "Help me plan a day out somewhere new in my own country. I don't need flights or a hotel.":
    "Ajuda-me a planear um dia num lugar novo no meu país. Não preciso de voos nem de hotel.",
  "Search for": "Procurar",
  "Flights only": "Só voos",
  "Stays only": "Só alojamento",
  "Flights and stays": "Voos e alojamento",
  "Compare options on the providers’ websites, then add the links you want to keep. No flight or hotel is required.":
    "Compara opções nos sites dos fornecedores e guarda as ligações que te interessam. Não é obrigatório incluir voos ou hotéis.",
  "Explore places": "Explorar lugares",
  "External searches show current availability on the provider’s site. They are not quotes or reservations from us.":
    "As pesquisas externas mostram a disponibilidade no site do fornecedor. Não são orçamentos nem reservas feitas por nós.",
  "Load more trips": "Carregar mais viagens",
  "The planner is busy or already answering your message. Please try again shortly.":
    "O assistente está ocupado ou já está a responder à tua mensagem. Tenta novamente dentro de momentos.",
  "Invalid history cursor":
    "Não foi possível continuar a lista de viagens. Recarrega a página.",
  "Add a destination and start date before searching.":
    "Adiciona um destino e uma data de início antes de pesquisar.",
  "Add a departure city to search for flights.":
    "Adiciona uma cidade de partida para pesquisar voos.",
  "Accommodation search needs a checkout date after check-in.":
    "A pesquisa de alojamento precisa de uma data de saída posterior à entrada.",
  Language: "Idioma",
  "Say it sorted home": "Página inicial da Say it sorted",
  "Say it sorted | AI Travel Planning for Remote Workers":
    "Say it sorted | Viagens com IA para quem trabalha à distância",
  "A new city. A better routine. Tell Say it sorted what you have in mind and explore flights, stays, and a clear travel brief for your next chapter.":
    "Uma nova cidade. Uma rotina melhor. Conta à Say it sorted o que tens em mente e descobre voos, alojamentos e um plano claro para o teu próximo capítulo.",
  "Loading...": "A carregar…",
  "Skip to content": "Saltar para o conteúdo",
  "Main navigation": "Navegação principal",
  "The destinations": "Destinos",
  "How it works": "Como funciona",
  "The travel brief": "O plano de viagem",
  PREVIEW: "EXEMPLO",
  "My trips": "As minhas viagens",
  "Log in": "Entrar",
  "Log In": "Entrar",
  "Plan a trip": "Planear viagem",
  "Close menu": "Fechar menu",
  "Open menu": "Abrir menu",
  "LESS LOGISTICS. MORE LIVING.": "MENOS LOGÍSTICA. MAIS VIDA.",
  "Your life.": "A tua vida.",
  "A little more": "Um pouco mais",
  "out there.": "lá fora.",
  "A new city. A better routine. A flight out.":
    "Uma nova cidade. Uma rotina melhor. Uma partida.",
  "Build your next stay around your work and your life.":
    "Planeia a próxima estadia à medida do teu trabalho e da tua vida.",
  "Bring your ideas. We’ll help you see how they fit.":
    "Traz as tuas ideias. Ajudamos-te a juntar as peças.",
  "Find my next chapter": "Encontrar o próximo capítulo",
  "See a travel brief": "Ver um plano de viagem",
  "Built for people who can work from anywhere.":
    "Feito para quem pode trabalhar de qualquer lugar.",
  "YOUR NEXT CHAPTER ↗": "O TEU PRÓXIMO CAPÍTULO ↗",
  "Lisbon’s terracotta rooftops below São Jorge Castle":
    "Os telhados de Lisboa aos pés do Castelo de São Jorge",
  "OPEN TO POSSIBILITY": "ABERTO A NOVAS POSSIBILIDADES",
  "THE WORLD IS YOUR WORKSPACE": "O MUNDO É O TEU LOCAL DE TRABALHO",
  "Olá, Lisbon.": "Olá, Lisboa.",
  "Explore the Lisbon sample travel brief":
    "Explorar o exemplo de plano para Lisboa",
  "NEXT STOP": "PRÓXIMA PARAGEM",
  "A change of scenery.": "Uma mudança de ares.",
  "Your workdays, bases + weekends": "Trabalho, estadias e fins de semana",
  "GO SOMEWHERE THAT FEELS LIKE YOU.":
    "VAI PARA UM LUGAR QUE TENHA A TUA CARA.",
  "01 / THE POSSIBILITIES": "01 / AS POSSIBILIDADES",
  "Where are we taking you?": "Para onde vamos?",
  "A rough idea is a good place to start.":
    "Uma ideia, mesmo vaga, já é um bom começo.",
  "Tell us about your trip": "Conta-nos a tua ideia de viagem",
  "A month in Lisbon, working London hours. Quiet calls, no car, and weekends by the coast. Help me think it through…":
    "Um mês em Lisboa, a trabalhar no horário de Londres. Chamadas tranquilas, sem carro e fins de semana junto ao mar. Ajuda-me a pensar no plano…",
  "Your next chapter starts with a conversation":
    "O próximo capítulo começa com uma conversa",
  "Let’s plan it": "Vamos planear",
  "Or start here": "Ou começa por aqui",
  "A month in Lisbon": "Um mês em Lisboa",
  "A slower week in Bali": "Uma semana sem pressa em Bali",
  "Mexico City, here I come": "Cidade do México, aí vou eu",
  "02 / SOMEWHERE GOOD": "02 / UM BOM LUGAR",
  "New timezone. Same you.": "Outro fuso horário. A mesma pessoa.",
  "For the places you’ve saved. And the ones you haven’t found yet.":
    "Para os lugares que já guardaste. E os que ainda tens por descobrir.",
  "Filter destinations": "Filtrar destinos",
  "All places": "Todos",
  "City energy": "Vida urbana",
  "Slow living": "Sem pressa",
  Lisbon: "Lisboa",
  Indonesia: "Indonésia",
  "Mexico City": "Cidade do México",
  Mexico: "México",
  "A different kind of office": "Outro tipo de escritório",
  "Hillside cafés. Atlantic weekends.":
    "Cafés nas colinas. Fins de semana no Atlântico.",
  "Find your own rhythm": "Encontra o teu ritmo",
  "Morning surf. A little more headspace.":
    "Surf de manhã. Mais espaço para respirar.",
  "Stay curious, stay a while": "Segue a curiosidade. Fica mais um pouco.",
  "Creative neighbourhoods. Endless discovery.":
    "Bairros criativos. Sempre algo para descobrir.",
  "I'd like to plan a trip to {destination}.":
    "Gostava de planear uma viagem para {destination}.",
  "A little inspiration. Your trip can start anywhere.":
    "Um pouco de inspiração. A tua viagem pode começar em qualquer lugar.",
  "YOU PICK THE PIN. WE HELP WITH THE PLAN.":
    "ESCOLHES O DESTINO. AJUDAMOS COM O PLANO.",
  "03 / FROM IDEA TO ITINERARY": "03 / DA IDEIA AO PLANO",
  "Less tab hopping.": "Menos separadores.",
  "More actual going.": "Mais viagens a acontecer.",
  "One conversation to bring your travel plans into focus. You make the final call.":
    "Uma conversa para dar forma às tuas ideias. A decisão final é sempre tua.",
  "Start with your kind of life.": "Começa pela vida que queres.",
  "Your working hours, a place you’re curious about, or a booking you already have. You don’t need all the answers to start.":
    "O teu horário de trabalho, um lugar que te desperta curiosidade ou uma reserva que já tens. Não precisas de ter todas as respostas para começar.",
  "Build a stay that fits.": "Cria uma estadia à tua medida.",
  "Bring bases, workspaces, experiences, and practical details together. Check local work hours, missing nights, and the cost of changing your mind.":
    "Junta alojamentos, espaços de trabalho, experiências e detalhes práticos. Confere os horários locais, as noites por planear e o custo de mudar de ideias.",
  "Keep the whole picture.": "Vê o plano completo.",
  "Your own saved travel brief, built from your plan. Keep suggestions separate from confirmed bookings, and see what still needs checking.":
    "Um plano de viagem guardado, feito à tua medida. Distingue sugestões de reservas confirmadas e vê o que ainda falta verificar.",
  "TRAVEL BRIEF / 001": "PLANO DE VIAGEM / 001",
  "A little Lisbon.": "Um pouco de Lisboa.",
  "A lot to look forward to.": "Muito para descobrir.",
  "YOUR WORK. YOUR STAY. YOUR OWN RHYTHM.":
    "O TEU TRABALHO. A TUA ESTADIA. O TEU RITMO.",
  "EVERY DETAIL, IN ITS PLACE": "CADA DETALHE NO SEU LUGAR",
  "A plan you’ll": "Um plano que",
  "actually want to open.": "vais querer abrir.",
  "Your bases, your working week, your next steps. A saved brief that grows with the plan, with clear costs and honest unknowns.":
    "As tuas estadias, a tua semana de trabalho, os próximos passos. Um plano que evolui contigo, com custos claros e dúvidas à vista.",
  "Explore a sample brief": "Explorar um exemplo",
  "THERE’S A WHOLE WORLD OUT THERE.": "HÁ UM MUNDO INTEIRO LÁ FORA.",
  "Make yourself": "Sente-te",
  "at home in it.": "em casa nele.",
  "Let’s find your next chapter": "Vamos encontrar o próximo capítulo",
  "A little less planning. A little more living.":
    "Um pouco menos de planos. Um pouco mais de vida.",
  "Back to top ↑": "Voltar ao início ↑",
  "YOUR NEXT CHAPTER AWAITS": "O PRÓXIMO CAPÍTULO ESTÁ À TUA ESPERA",
  "Good to have you back.": "É bom ter-te de volta.",
  "Pick up where your plans left off.":
    "Continua os teus planos de onde ficaram.",
  "MAKE ROOM FOR SOMEWHERE NEW": "DÁ ESPAÇO A UM NOVO LUGAR",
  "Your next chapter starts here.": "O próximo capítulo começa aqui.",
  "Create an account to keep your travel plans together.":
    "Cria uma conta para teres os teus planos de viagem num só lugar.",
  "YOUR STARTING POINT": "O TEU PONTO DE PARTIDA",
  Email: "E-mail",
  Password: "Palavra-passe",
  "Name (optional)": "Nome (opcional)",
  "Your name": "O teu nome",
  "your@email.com": "teu@email.com",
  "At least 6 characters": "Pelo menos 6 caracteres",
  "Password must be at least 6 characters":
    "A palavra-passe deve ter pelo menos 6 caracteres.",
  "Logging in...": "A entrar…",
  "Creating account...": "A criar conta…",
  "Sign Up": "Criar conta",
  "Sign up": "Criar conta",
  "Don't have an account?": "Ainda não tens conta?",
  "Already have an account?": "Já tens conta?",
  or: "ou",
  "We couldn’t connect. Please try again in a moment.":
    "Não foi possível ligar. Tenta novamente dentro de momentos.",
  "Login failed": "Não foi possível iniciar sessão.",
  "Signup failed": "Não foi possível criar a conta.",
  "Google login failed": "Não foi possível entrar com o Google.",
  "Email already registered": "Este e-mail já está registado.",
  "Invalid email or password": "E-mail ou palavra-passe incorretos.",
  "Email and password required": "Indica o e-mail e a palavra-passe.",
  "Invalid Google token": "A sessão do Google expirou. Tenta entrar novamente.",
  "User not found": "Utilizador não encontrado.",
  Unauthorized: "Inicia sessão para continuar.",
  Today: "Hoje",
  Yesterday: "Ontem",
  "Last 7 Days": "Últimos 7 dias",
  Older: "Anteriores",
  "New trip": "Nova viagem",
  "New Chat": "Nova conversa",
  "Your next chapter": "O teu próximo capítulo",
  "Loading sessions...": "A carregar conversas…",
  "A blank page. A world of places.":
    "Uma página em branco. Um mundo de lugares.",
  "Your travel conversations will live here.":
    "As tuas conversas de viagem ficam aqui.",
  "Explore a sample brief ↗": "Explorar um exemplo ↗",
  "Delete {title}": "Eliminar {title}",
  conversation: "conversa",
  "Delete this conversation?": "Queres eliminar esta conversa?",
  User: "Utilizador",
  "Log out": "Sair",
  "Open trip history": "Abrir histórico de viagens",
  "Close trip history": "Fechar histórico de viagens",
  Conversation: "Conversa",
  "Your stay": "A tua estadia",
  "Workspace views": "Vistas do espaço de planeamento",
  "Let’s figure it out.": "Vamos pensar nisso.",
  "Your work. Your plans. A little room for possibility.":
    "O teu trabalho. Os teus planos. Espaço para novas possibilidades.",
  "Travel conversation": "Conversa sobre a viagem",
  "START ANYWHERE": "COMEÇA POR ONDE QUISERES",
  "A place to go.": "Um lugar para ir.",
  "A life to fit in.": "Uma vida para conciliar.",
  "Bring an idea, a dilemma, or a booking you already have. We’ll build around what matters to you.":
    "Traz uma ideia, uma dúvida ou uma reserva que já tenhas. Partimos do que é importante para ti.",
  "I’m still exploring": "Ainda estou a explorar",
  "I want to work from somewhere new for a month, but I haven’t decided where. Can we think it through?":
    "Quero trabalhar de um lugar novo durante um mês, mas ainda não decidi onde. Podemos pensar nisso?",
  "Fit it around my work": "Conciliar com o meu trabalho",
  "Help me plan a stay around my working hours. I want time to enjoy the place too.":
    "Ajuda-me a planear uma estadia à volta do meu horário de trabalho. Também quero tempo para aproveitar o lugar.",
  "I already have a plan": "Já tenho algumas ideias",
  "I already have some bookings and ideas. Help me bring them together and spot what’s missing.":
    "Já tenho algumas reservas e ideias. Ajuda-me a juntá-las e a perceber o que falta.",
  "Thinking it through…": "A pensar no plano…",
  "Save or cancel your plan edits to continue the conversation.":
    "Guarda ou cancela as alterações ao plano para continuar a conversa.",
  "Message your travel agent": "Mensagem para o teu assistente de viagem",
  "What are you thinking?": "O que tens em mente?",
  "Send message": "Enviar mensagem",
  "Ideas stay editable. Bookings stay in your hands. Shift + Enter for a new line.":
    "As ideias podem mudar. As reservas continuam nas tuas mãos. Shift + Enter para uma nova linha.",
  "Opening your workspace…": "A abrir o teu espaço de planeamento…",
  "Reload workspace": "Recarregar",
  "Couldn’t load this plan.": "Não foi possível carregar este plano.",
  "The planner service needs updating before this workspace can open.":
    "O serviço de planeamento precisa de ser atualizado para abrir este plano.",
  "The planner returned an incomplete reply. Please reload before trying again.":
    "A resposta ficou incompleta. Recarrega a página antes de tentar novamente.",
  "Couldn’t send your message.": "Não foi possível enviar a mensagem.",
  "Couldn’t save changes.": "Não foi possível guardar as alterações.",
  "Saved. Your costs, work hours, and checks are up to date.":
    "Guardado. Os custos, horários e verificações estão atualizados.",
  "Searching flight and stay providers…":
    "A procurar opções de voos e alojamento…",
  "Search failed.": "Não foi possível concluir a pesquisa.",
  "No {items} option was available.":
    "Não havia opções disponíveis de {items}.",
  flight: "voo",
  stay: "alojamento",
  " or ": " ou ",
  "That didn’t go through. Please try again.":
    "Não foi possível concluir. Tenta novamente.",
  "Some details need checking. Review the dates, times, and required fields.":
    "Há detalhes a verificar. Revê as datas, os horários e os campos obrigatórios.",
  "Failed to fetch": "Não foi possível ligar ao serviço. Tenta novamente.",
  "Your stay plan": "O teu plano de estadia",
  "YOUR STAY, TAKING SHAPE": "A TUA ESTADIA A GANHAR FORMA",
  Saved: "Guardado",
  "The essentials": "O essencial",
  Edit: "Editar",
  "Somewhere new": "Um novo lugar",
  "from {origin}": "de {origin}",
  "Dates open": "Datas em aberto",
  traveller: "viajante",
  "KNOWN COST ESTIMATES": "ESTIMATIVAS DE CUSTOS CONHECIDOS",
  "Still open": "Em aberto",
  "Budget {amount}": "Orçamento {amount}",
  "{amount} remaining in this currency": "{amount} disponíveis nesta moeda",
  "{count} item is unpriced or missing dates.":
    "{count} elemento sem preço ou sem datas.",
  "{count} items are unpriced or missing dates.":
    "{count} elementos sem preço ou sem datas.",
  "Only added items are included. Currencies stay separate.":
    "Só estão incluídos os elementos adicionados. As moedas são apresentadas em separado.",
  "BUILD YOUR STAY": "CONSTRÓI A TUA ESTADIA",
  "A base": "Um alojamento",
  "A workspace": "Um espaço de trabalho",
  "An experience": "Uma experiência",
  "A move": "Uma deslocação",
  "To resolve": "Por resolver",
  "A plan, not a form to finish.": "Um plano que cresce contigo.",
  "Ideas from your conversation appear here. You can also add a place, a booking, a weekend escape, or something to resolve yourself.":
    "As ideias da conversa aparecem aqui. Também podes adicionar um lugar, uma reserva, uma escapadinha ou algo que ainda falta resolver.",
  "Set work hours & preferences": "Definir horário e preferências",
  "Search travel": "Procurar opções",
  "Open travel brief": "Abrir plano de viagem",
  "Live search needs a route and dates. It adds flight/stay options without booking or sending email.":
    "A pesquisa precisa de um percurso e de datas. Adiciona opções de voos e alojamento, sem fazer reservas nem enviar e-mails.",
  "The shape of your stay": "A tua estadia, ao detalhe",
  "Edit {type}": "Editar: {type}",
  "Cancel edits": "Cancelar alterações",
  "Plan name": "Nome do plano",
  From: "Partida",
  Destination: "Destino",
  "Still exploring": "Ainda a explorar",
  "Start date": "Data de início",
  "End date": "Data de fim",
  Budget: "Orçamento",
  Currency: "Moeda",
  "No budget set": "Sem orçamento definido",
  Travellers: "Viajantes",
  "What matters to you": "O que é importante para ti",
  "One preference per line\nQuiet calls, no car, surf twice a week…":
    "Uma preferência por linha\nChamadas tranquilas, sem carro, surf duas vezes por semana…",
  "Build around my working hours": "Planear à volta do meu horário de trabalho",
  "Work timezone": "Fuso horário do trabalho",
  "Work starts": "Início do trabalho",
  "Work ends": "Fim do trabalho",
  "Working days": "Dias de trabalho",
  Mon: "Seg",
  Tue: "Ter",
  Wed: "Qua",
  Thu: "Qui",
  Fri: "Sex",
  Sat: "Sáb",
  Sun: "Dom",
  "Prefer to finish by, in local time":
    "Hora limite desejada, no horário local",
  "We’ll check actual local hours against each dated base’s timezone. Overnight work is supported.":
    "Calculamos o horário local para cada alojamento com datas e fuso horário. Também são suportados turnos que atravessam a meia-noite.",
  "This item is protected from automatic chat edits. Changes you save here are your decision; they do not change a provider booking.":
    "Este elemento está protegido contra alterações automáticas pela conversa. As alterações que guardares aqui são uma decisão tua; não alteram reservas junto dos fornecedores.",
  Title: "Título",
  "An apartment, a weekend idea, a detail to resolve…":
    "Um apartamento, uma ideia para o fim de semana, um detalhe por resolver…",
  Type: "Tipo",
  Status: "Estado",
  Idea: "Ideia",
  Considering: "Em análise",
  "Booked by me · lock": "Reservado por mim · proteger",
  "Done · lock": "Concluído · proteger",
  "Place / neighbourhood": "Lugar / bairro",
  "Start / check-in": "Início / entrada",
  "End / checkout": "Fim / saída",
  "Start time": "Hora de início",
  "End time": "Hora de fim",
  "Local timezone": "Fuso horário local",
  "e.g. Europe/Lisbon": "por exemplo, Europe/Lisbon",
  "Cost estimate": "Estimativa de custo",
  Unknown: "Desconhecido",
  Charged: "Cobrança",
  "Once / total": "Uma vez / total",
  "Per night": "Por noite",
  "Per day": "Por dia",
  "Source or booking link": "Ligação da fonte ou da reserva",
  "Notes / details to check": "Notas / detalhes a confirmar",
  "What you know, what you like, what still needs confirming.":
    "O que sabes, o que te agrada e o que ainda falta confirmar.",
  "Adding a link saves it for reference; it doesn’t read the page or verify its claims.":
    "A ligação fica guardada como referência; o conteúdo da página não é lido nem verificado.",
  "IF YOU SAVE THESE CHANGES": "SE GUARDARES ESTAS ALTERAÇÕES",
  "{count} item still needs a usable cost estimate.":
    "{count} elemento ainda precisa de uma estimativa de custo.",
  "{count} items still need a usable cost estimate.":
    "{count} elementos ainda precisam de uma estimativa de custo.",
  "No conflicts found by the available checks. This does not verify availability or suitability.":
    "Não foram encontrados conflitos nas verificações disponíveis. Isto não confirma a disponibilidade nem a adequação das opções.",
  "Checking…": "A verificar…",
  "Check changes": "Verificar alterações",
  "Saving…": "A guardar…",
  "Save changes": "Guardar alterações",
  Cancel: "Cancelar",
  "Couldn’t check changes.": "Não foi possível verificar as alterações.",
  "Remove “{title}” from your plan? This won’t cancel any booking.":
    "Remover «{title}» do plano? Isto não cancela nenhuma reserva.",
  "Remove {title}": "Remover {title}",
  Remove: "Remover",
  "Edit details": "Editar detalhes",
  "Booked by you · locked": "Reservado por ti · protegido",
  "Done · locked": "Concluído · protegido",
  idea: "ideia",
  considering: "em análise",
  booked: "reservado",
  done: "concluído",
  "Date open": "Data em aberto",
  checkout: "saída",
  " / night": " / noite",
  " / day": " / dia",
  "Practical detail": "Detalhe prático",
  "Cost not set": "Custo por definir",
  "{amount} total": "{amount} no total",
  "Your notes": "As tuas notas",
  "Suggested · unverified": "Sugestão · por verificar",
  "Provider quote": "Preço do fornecedor",
  "Open source": "Abrir fonte",
  "Added or edited by you; provider details have not been independently verified.":
    "Adicionado ou editado por ti; os detalhes do fornecedor não foram verificados de forma independente.",
  "Updated in conversation; check changed details against the original source.":
    "Atualizado na conversa; confirma as alterações na fonte original.",
  local: "hora local",
  "(+1 day)": "(+1 dia)",
  "Your working hours during this stay, including clock changes.":
    "O teu horário de trabalho durante a estadia, incluindo mudanças da hora.",
  "THINGS TO THINK THROUGH": "PONTOS A TER EM CONTA",
  "{title} starts before your trip.": "{title} começa antes da tua viagem.",
  "{title} finishes after your trip.": "{title} termina depois da tua viagem.",
  "{title}: confirm internet, a desk, and call privacy before relying on it for work.":
    "{title}: confirma a internet, uma secretária e privacidade para chamadas antes de contares com este espaço para trabalhar.",
  "{title} and {other} overlap. Check whether you intend to pay for both.":
    "{title} e {other} coincidem nas datas. Confirma se pretendes pagar os dois.",
  "{count} night has no dated base yet.":
    "{count} noite ainda não tem alojamento com datas definidas.",
  "{count} nights have no dated base yet.":
    "{count} noites ainda não têm alojamento com datas definidas.",
  "Known {currency} costs exceed your budget. Unpriced items may add more.":
    "Os custos conhecidos em {currency} ultrapassam o orçamento. Os elementos sem preço podem aumentar o total.",
  "Add a timezone to {title} to check your local working hours.":
    "Adiciona um fuso horário a {title} para verificar o horário de trabalho local.",
  "{title}: your working day ends after your preferred local cutoff.":
    "{title}: o dia de trabalho termina depois da hora limite local que preferes.",
  "{title} is on a usual workday. Add times and a timezone to check overlap.":
    "{title} coincide com um dia de trabalho habitual. Adiciona as horas e o fuso horário para verificar conflitos.",
  "{title} overlaps your working hours.":
    "{title} coincide com o teu horário de trabalho.",
  "Back to your workspace": "Voltar ao planeamento",
  "Opening your brief…": "A abrir o plano de viagem…",
  "YOUR PRIVATE TRAVEL BRIEF · REVISION {revision}":
    "O TEU PLANO PRIVADO · VERSÃO {revision}",
  "Print / save PDF": "Imprimir / guardar PDF",
  "SAY IT SORTED / A CHAPTER OF YOUR OWN": "SAY IT SORTED / UM CAPÍTULO SÓ TEU",
  "THE POSSIBILITIES ARE OPEN": "AS POSSIBILIDADES ESTÃO EM ABERTO",
  "From {origin}": "De {origin}",
  in: "em",
  "A rhythm for your working days.": "Um ritmo para os teus dias de trabalho.",
  "Budget: {amount}.": "Orçamento: {amount}.",
  "Only listed items are included; different currencies have not been converted.":
    "Só estão incluídos os elementos listados; as diferentes moedas não foram convertidas.",
  "The pieces of your stay.": "As peças da tua estadia.",
  "Your plan is a starting point. Add places and ideas in your workspace.":
    "O plano é um ponto de partida. Adiciona lugares e ideias no teu espaço de planeamento.",
  "Before it all comes together.": "Antes de juntar todas as peças.",
  "No conflicts found by the available checks. Availability, suitability, and booking conditions still need your review.":
    "Não foram encontrados conflitos nas verificações disponíveis. Ainda precisas de rever a disponibilidade, a adequação e as condições das reservas.",
  "Go well.": "Boa viagem.",
  "This brief reflects your saved plan. Suggested details are unverified; “booked” means you marked an item as booked. The planner has not made, changed, or cancelled reservations.":
    "Este documento reflete o plano guardado. As sugestões não estão verificadas; «reservado» significa que marcaste o elemento como reservado. O assistente não fez, alterou ou cancelou reservas.",
  "This plan needs the updated planner service.":
    "Este plano precisa da versão atualizada do serviço de planeamento.",
  "Back to exploring": "Voltar à descoberta",
  "SAMPLE BRIEF": "EXEMPLO DE PLANO",
  "A little look at what’s possible.": "Uma amostra do que é possível.",
  "SAY IT SORTED / THE TRAVEL BRIEF": "SAY IT SORTED / O PLANO DE VIAGEM",
  "NO. 001 — LISBON": "N.º 001 — LISBOA",
  "A lot to look": "Muito para",
  "forward to.": "descobrir.",
  "Two weeks to find a new rhythm.": "Duas semanas para encontrar outro ritmo.",
  "Your work, your weekends, your kind of city.":
    "O teu trabalho, os teus fins de semana, a tua cidade.",
  "AN ILLUSTRATIVE TRIP, READY TO EXPLORE":
    "UMA VIAGEM DE EXEMPLO, PRONTA A EXPLORAR",
  "THE DATES": "AS DATAS",
  "THE TRAVELLER": "O VIAJANTE",
  "1 person · 13 nights": "1 pessoa · 13 noites",
  "THE ROUTE": "O PERCURSO",
  "London → Lisbon": "Londres → Lisboa",
  "THE PACE": "O RITMO",
  "Work a little. Live a lot.": "Trabalha um pouco. Vive muito.",
  "Travel brief sections": "Secções do plano de viagem",
  Overview: "Visão geral",
  "Your itinerary": "O teu itinerário",
  "The budget": "O orçamento",
  "The essentials, considered.": "O essencial, bem pensado.",
  "YOUR FLIGHT": "O TEU VOO",
  "ILLUSTRATIVE OPTION": "OPÇÃO DE EXEMPLO",
  "London Heathrow": "Londres Heathrow",
  "Direct · 2h 45m": "Direto · 2 h 45 min",
  outbound: "ida",
  return: "regresso",
  Economy: "Económica",
  "Return flight estimate": "Estimativa de ida e volta",
  "YOUR PLACE": "O TEU ALOJAMENTO",
  "A base in Príncipe Real.": "Um alojamento no Príncipe Real.",
  "A private apartment in a walkable neighbourhood, with room to work and a city to explore outside.":
    "Um apartamento privado num bairro que se percorre a pé, com espaço para trabalhar e uma cidade para descobrir à porta.",
  "Private apartment": "Apartamento privado",
  "13 nights": "13 noites",
  " / night · illustrative": " / noite · exemplo",
  "THE NOMAD NOTE": "A NOTA NÓMADA",
  "A good workday starts before you open your laptop. Ask the host for a recent Wi-Fi speed test, a photo of the desk, and details about daytime noise before you book.":
    "Um bom dia de trabalho começa antes de abrires o portátil. Antes de reservar, pede ao anfitrião um teste recente à velocidade do Wi-Fi, uma fotografia da secretária e informações sobre o ruído durante o dia.",
  "A few things to make it yours.": "Alguns detalhes para ser mesmo tua.",
  "Stay in sync.": "Mantém o mesmo horário.",
  "Lisbon and London share a timezone in June. Your calendar can stay exactly where it is.":
    "Lisboa e Londres têm o mesmo fuso horário em junho. A tua agenda pode ficar tal como está.",
  "Go beyond your desk.": "Vai além da secretária.",
  "Leave room for the riverfront, a neighbourhood market, and a day on the coast.":
    "Deixa espaço para a zona ribeirinha, um mercado de bairro e um dia junto ao mar.",
  "Check the details.": "Confirma os detalhes.",
  "Confirm Wi-Fi, check-in, cancellation terms, and any local taxes directly with your host.":
    "Confirma o Wi-Fi, a hora de entrada, as condições de cancelamento e as taxas locais diretamente com o anfitrião.",
  "A rhythm, not a rigid schedule.": "Um ritmo, sem horários rígidos.",
  "A suggested pace for your stay. Activities are ideas, with no reservations or costs included.":
    "Uma sugestão de ritmo para a estadia. As atividades são ideias, sem reservas nem custos incluídos.",
  DAY: "DIA",
  ARRIVAL: "CHEGADA",
  "WORK + WANDER": "TRABALHAR + DESCOBRIR",
  "OFF THE CLOCK": "FORA DO HORÁRIO",
  "MAKE IT YOURS": "AO TEU RITMO",
  "Touch down. Settle in.": "Aterrar. Sentir-se em casa.",
  "Arrive in Lisbon, make your way to the apartment, and take a first walk through Príncipe Real.":
    "Chega a Lisboa, instala-te no apartamento e dá o primeiro passeio pelo Príncipe Real.",
  "Find your daily rhythm.": "Encontra o teu ritmo diário.",
  "Keep the mornings for focused work. Leave the afternoons open for neighbourhood cafés and the riverside.":
    "Reserva as manhãs para trabalhar com concentração. Deixa as tardes livres para os cafés do bairro e a zona ribeirinha.",
  "Take the long way round.": "Escolhe o caminho mais demorado.",
  "A weekend for Sintra’s winding trails or the coast at Cascais. Decide when you get there.":
    "Um fim de semana para os trilhos de Sintra ou a costa de Cascais. Decide quando lá chegares.",
  "Feel a little more local.": "Sente-te mais de cá.",
  "Back to your favourite coffee spot. A new neighbourhood after work. One last sunset before the flight home.":
    "Volta ao teu café preferido. Descobre outro bairro depois do trabalho. Aproveita um último pôr do sol antes de regressar.",
  "The numbers, in the open.": "As contas, sem surpresas.",
  "Illustrative estimates for one traveller. These are sample figures, not live quotes.":
    "Estimativas de exemplo para uma pessoa. Estes valores não são preços obtidos em tempo real.",
  "Example Lisbon trip budget in euros":
    "Exemplo de orçamento de viagem a Lisboa, em euros",
  "The detail": "O detalhe",
  "The estimate": "A estimativa",
  "Return flight · London to Lisbon": "Voo de ida e volta · Londres–Lisboa",
  "Private apartment · 13 nights × {amount}":
    "Apartamento privado · 13 noites × {amount}",
  "Flight + stay": "Voo + alojamento",
  "Leave room for the everyday.": "Deixa margem para o dia a dia.",
  "Meals, coworking, airport transfers, local transport, insurance, baggage, and tourist taxes are not included. Check the provider’s final total and cancellation policy before paying.":
    "Refeições, coworking, transfers, transportes locais, seguro, bagagem e taxas turísticas não estão incluídos. Confirma o preço final e as condições de cancelamento junto do fornecedor antes de pagar.",
  "YOUR NEXT CHAPTER": "O TEU PRÓXIMO CAPÍTULO",
  "Let’s make this one yours.": "Vamos criar o teu plano.",
  "Tell us your dates and budget to search for real options.":
    "Diz-nos as datas e o orçamento para procurar opções reais.",
  "Plan my own trip": "Planear a minha viagem",
  "Sample content for illustration. No live availability, reservations, or verified property details.":
    "Conteúdo de exemplo. Sem disponibilidade em tempo real, reservas ou detalhes de alojamento verificados.",
  "Prices and suggestions are examples. Nothing has been booked.":
    "Os preços e as sugestões são exemplos. Não foi feita nenhuma reserva.",
  "GO WELL.": "BOA VIAGEM.",
  "Your travel agent is currently unavailable. Your message hasn’t been sent. Please try again later.":
    "O assistente de viagem está indisponível. A mensagem não foi enviada. Tenta novamente mais tarde.",
  "I couldn’t reach the planning service. Your saved plan is unchanged. Please try again.":
    "Não foi possível contactar o serviço de planeamento. O plano guardado não foi alterado. Tenta novamente.",
  "I couldn’t safely apply that change. Your saved plan is unchanged. Try a smaller change; booked items can be edited directly in the plan.":
    "Não foi possível aplicar essa alteração com segurança. O plano guardado não mudou. Tenta uma alteração mais pequena; os elementos reservados podem ser editados diretamente no plano.",
  "Your plan has changed. Reload it before sending this message.":
    "O plano foi alterado. Recarrega-o antes de enviar esta mensagem.",
  "This plan changed in another window. Reload it before trying again.":
    "O plano foi alterado noutra janela. Recarrega-o antes de tentar novamente.",
  "This plan changed. Reload it before saving your edits.":
    "O plano foi alterado. Recarrega-o antes de guardar as tuas alterações.",
  "This plan was saved in another window. Reload it before trying again.":
    "O plano foi guardado noutra janela. Recarrega-o antes de tentar novamente.",
  "Plan not found": "Plano não encontrado.",
  "Session not found": "Conversa não encontrada.",
  "Save a plan before searching": "Guarda um plano antes de pesquisar.",
  "Add an origin, destination, start date, and end date before searching.":
    "Adiciona a partida, o destino e as datas de início e fim antes de pesquisar.",
  "Flight and stay search needs at least one overnight stay.":
    "A pesquisa de voos e alojamento precisa de pelo menos uma noite de estadia.",
  "Travel search currently quotes in EUR. You can keep other currencies in your plan manually.":
    "A pesquisa apresenta atualmente preços em EUR. Podes adicionar outras moedas ao plano manualmente.",
  "Live travel search is currently unavailable. You can still add your own options.":
    "A pesquisa de viagens está indisponível. Podes continuar a adicionar as tuas próprias opções.",
  "Search finished. Review the provider options in your plan; nothing has been booked.":
    "Pesquisa concluída. Revê as opções dos fornecedores no plano; não foi feita nenhuma reserva.",
  "No options found. Try different dates or add your own links.":
    "Não foram encontradas opções. Tenta outras datas ou adiciona as tuas ligações.",
  "Value error, Use an IANA timezone, such as Europe/London or Asia/Makassar":
    "Usa um fuso horário IANA, como Europe/Lisbon, Europe/London ou Asia/Makassar.",
  "Value error, Block dates must be in order and within 366 days":
    "As datas do elemento devem estar por ordem e abranger, no máximo, 366 dias.",
  "Value error, A plan must end after it starts, within 366 days":
    "O plano deve terminar depois de começar e abranger, no máximo, 366 dias.",
  "Value error, Source links must be absolute http or https URLs":
    "A ligação da fonte deve começar por http:// ou https://.",
  "Value error, Enter a local clock time without an offset; specify the timezone separately":
    "Indica uma hora local sem diferença UTC; escolhe o fuso horário no campo próprio.",
  "Value error, Each preference must contain 1–250 characters":
    "Cada preferência deve ter entre 1 e 250 caracteres.",
};
